const LOGO_SRC = `${process.env.PUBLIC_URL}/logo.svg?v=4`;

export const LogoMark = ({ size = 32, className = "" }) => (
  <img src={LOGO_SRC} width={size} height={size} alt="" aria-hidden="true" draggable="false"
    className={`shrink-0 select-none ${className}`} style={{ width: size, height: size }} />
);

export const BrandLockup = ({ size = 32, onDark = false, textClass = "text-[17px]", wordClass = "" }) => (
  <span className="flex items-center gap-2.5 min-w-0" data-testid="brand-lockup">
    <LogoMark size={size} className="transition-transform duration-200 group-hover:scale-105" />
    <span className={`font-display font-bold tracking-tight ${textClass} ${onDark ? "text-white" : "text-ink"} ${wordClass}`}>GetInterviewed</span>
  </span>
);
